import React, { useCallback, useState } from 'react';
import { useQuery } from 'hooks/apollo';
import { useTranslation } from 'react-i18next';
import { TableBody, TableCell, TableHead } from '@mui/material';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { FIELD_DECIMAL_PLACES_CONFIG_QUERY } from './queries';
import NumericPrecisionsListItemContainer from './NumericPrecisionsListItemContainer';
import { NavPillsCardContainer, StyledTable, StyledTableRow } from 'components/common/Styles';
import WrappedFakeText from 'components/common/WrappedFakeText';
import { RoundedHeaderTableRow, ThemedHeaderTableCell } from 'components/common/table/TableStyles';

const NumericPrecisionsListContainer = () => {
  const { t } = useTranslation();

  const [numericPrecisions, setNumericPrecisions] = useState([]);

  const { loading } = useQuery(FIELD_DECIMAL_PLACES_CONFIG_QUERY, {
    onCompleted: data => {
      const newNumericPrecisions = data?.fieldDecimalPlacesConfig || [];
      setNumericPrecisions(newNumericPrecisions);
    }
  });

  const getNumericPrecisionKey = useCallback(numericPrecision => numericPrecision.key || `${numericPrecision.fieldType}`, []);

  return (
    <NavPillsCardContainer icon={ListAltIcon}>
      <StyledTable>
        <TableHead>
          <RoundedHeaderTableRow>
            <ThemedHeaderTableCell width='40%'>{t('NumericPrecisions.ParamName')}</ThemedHeaderTableCell>
            <ThemedHeaderTableCell>{t('NumericPrecisions.DecimalsPlaces')}</ThemedHeaderTableCell>
            <ThemedHeaderTableCell>{t('NumericPrecisions.MaximumDecimals')}</ThemedHeaderTableCell>
            <ThemedHeaderTableCell align='right' width='120px'>
              {t('Actions')}
            </ThemedHeaderTableCell>
          </RoundedHeaderTableRow>
        </TableHead>
        <TableBody>
          {loading && (
            <StyledTableRow>
              <TableCell colSpan={4} sx={{ px: 0.5 }}>
                <WrappedFakeText />
              </TableCell>
            </StyledTableRow>
          )}
          {!loading &&
            numericPrecisions.length > 0 &&
            numericPrecisions.map(numericPrecision => (
              <NumericPrecisionsListItemContainer key={getNumericPrecisionKey(numericPrecision)} numericPrecision={numericPrecision} />
            ))}
        </TableBody>
      </StyledTable>
    </NavPillsCardContainer>
  );
};

export default NumericPrecisionsListContainer;
